import { ACTIONS_OZON_ORDERS } from '../actions/ozonOrders';

export const ozonOrders = (state = {}, action) => {
  switch (action.type) {
    case ACTIONS_OZON_ORDERS.ADD_MAP: {
      return { ...state, map: action.map };
    }
    case ACTIONS_OZON_ORDERS.CHANGE_OZON_ORDER_MAP: {
      const { item } = action;
      return { ...state, map: { ...state.map, [item.chrt_id]: { ...state.map[item.chrt_id], ...item } } };
    }

    default:
      return state;
  }
};
